import { render, staticRenderFns } from "./mailInformation.vue?vue&type=template&id=54bea7b7&scoped=true&"
import script from "./mailInformation.vue?vue&type=script&lang=js&"
export * from "./mailInformation.vue?vue&type=script&lang=js&"
import style0 from "./mailInformation.vue?vue&type=style&index=0&id=54bea7b7&lang=scss&scoped=true&"
import style1 from "./mailInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bea7b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VDialog,VForm,VIcon,VRow,VTextField,VTextarea})
